import React from 'react';
import { Images } from 'utils';
import { DateRow, EditWithIcon, HtmlConvertor, TextRow } from 'components';

export const abcHead = [
    { name: 'displayId', rowName: 'displayId', title: 'Appt ID', searchKey: 'DISPLAY_ID' },
    { name: 'createdBy', title: 'Created By', disabled: true },
    { name: 'createdAt', title: 'Added Date', disabled: true, iconType: 'date' },
    { name: 'antecedent', title: 'Antecedent', searchKey: 'ANTECEDENT' },
    { name: 'behavior', title: 'Behavior', searchKey: 'BEHAVIOR' },
    { name: 'consequence', title: 'Consequence', searchKey: 'CONSEQUENCE' },
    { name: 'additionalNote', title: 'Additional Note', searchKey: 'ADDITIONAL_NOTE' },
    { name: 'action', title: 'Action', custom: false, disabled: true },
];

export const abcBody = [
    { rowText: (item) => <TextRow name={item?.appt?.displayId} /> },
    { rowText: (item) => <TextRow name={item?.creator} /> },
    { rowText: (item) => <DateRow date={item?.createdAt} /> },
    { rowText: (item) => <HtmlConvertor text={item?.antecedent} /> },
    { rowText: (item) => <HtmlConvertor text={item?.behavior} /> },
    { rowText: (item) => <HtmlConvertor text={item?.consequence} /> },
    { rowText: (item) => <HtmlConvertor text={item?.note} /> },
    {
        button: (fn) => (
            <div className="flex-align-center" style={{ gap: 12 }}>
                <EditWithIcon icon={Images.edit} handleClick={() => fn('edit')} />
                <EditWithIcon icon={Images.deleteTag} handleClick={() => fn('delete')} />
            </div>
        ),
        notClickable: true,
    },
];

export const ACTION_TYPE = 'GET_ABCS';

export const abcNotYet = {
    title: 'No Abc Information',
    subTitle: 'Start by adding your first Abc to manage their information.',
    image: Images.noClientYet,
};

export const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
        { label: 'Bold', style: 'BOLD' },
        { label: 'Italic', style: 'ITALIC' },
    ],
    BLOCK_TYPE_BUTTONS: [
        { label: 'UL', style: 'unordered-list-item' },
        { label: 'OL', style: 'ordered-list-item' },
    ],
};
